var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('ed-title-nav',{attrs:{"title":_vm.$t('Payments'),"subtitle":_vm.$t('Manage Invoices & Payments'),"tabs":_vm.tabs}}),_vm._v(" "),_c('legacy-container',{attrs:{"url":_vm.url}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f05f91d6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_modules/Invoices/suppliers-remit-payment.vue
// module id = Nie0
// module chunks = 12